/** Accessible on/off switch — round track, fluid thumb, accent glow when on. */
export function Switch({
  checked,
  onChange,
  label,
  hint,
  disabled = false,
  tone = "default",
  layout = "default",
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  hint?: string;
  disabled?: boolean;
  tone?: "default" | "warn";
  layout?: "default" | "compact";
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      className={[
        "so-switch",
        checked ? "so-switch--on" : "",
        tone === "warn" ? "so-switch--warn" : "",
        layout === "compact" ? "so-switch--compact" : "",
      ]
        .filter(Boolean)
        .join(" ")}
      onClick={() => onChange(!checked)}
    >
      <span className="so-switch__track" aria-hidden="true">
        <span className="so-switch__thumb" />
      </span>
      <span className="so-switch__text">
        <span className="so-switch__label">{label}</span>
        {hint !== undefined && hint !== "" ? (
          <span className="so-switch__hint">{hint}</span>
        ) : null}
      </span>
    </button>
  );
}
